/**
 * Image Gallery Plugin
 * @requires Swipe function
 * @param {selector} element
 * @param {Object} options
 */
var Gallery = function(element, options){
    this.element = element;
    this.$element = $(element);
    this.settings = $.extend({}, this.defaults, options);
    this.origElement = this.$element.clone();
    this.init();
};

Gallery.prototype = {

    // shorthand for using prototype
    constructor : Gallery,

    // default options
    defaults : {
        transition : 1000,
        type : 'slideshow',
        delay : 3000,
        autoStart : false,
        continuous : true,
        callback : function(index, elem){},
        transitionEnd : function(index, elem){}
    },

    init : function(){
        var _this = this;

        var _transition = _this.$element.attr('data-transition'),
            _delay = _this.$element.attr('data-delay'),
            _type = _this.$element.attr('data-type') || _this.settings.type;

        if ( window.timers === undefined ){
            window.timers = {};
        }

        // Use data attributes for settings
        if ( _transition ) _this.settings.transition = _transition;
        if ( _delay ) _this.settings.delay = _delay;

        if ( _type === 'gallery' && typeof Swipe !== 'undefined' ){
            _this.initSlideGallery();
        } else {
            _this.initFadeGallery();
        }
    },

    initSlideGallery : function(){
        var _this = this,
            $thumbs = _this.$element.find('.thumbnails li'),
            activeClass = 'active ui-border-primary-color';

        // add gallery classes so we can target them
        _this.$element.addClass('image-gallery');

        // add the right class names for Swipe to work
        _this.$element.addClass('swipe').find('.main-image').addClass('swipe-wrap').end();

        // init Swipe
        this.gallery = _this.$element.Swipe({
            //auto : _this.settings.delay,
            continuous : _this.settings.continuous,
            callback : function(index, elem){
                _this.settings.callback.call(_this, index, elem);
            },
            transitionEnd : function(index, elem){
                _this.settings.transitionEnd.call(_this, index, elem);
            }
        }).data('Swipe');

        // once gallery has loaded
        var $currentSlide = _this.$element.find('.js-gallery-slide:nth-child('+(_this.gallery.getPos() + 1)+')');
        var $slideMedia = $currentSlide.find('.js-gallery-slide-media');

        // set first slide thumb to active
        $thumbs.eq(0).addClass(activeClass);

        // calculate height of gallery arrows
        _this.calculateGalleryHeight();

        // thumbnail event handler
        _this.$element.on('click', '.thumbnails li', function(e){
            var $thumbs = _this.$element.find('.thumbnails li'),
                index = $thumbs.index($(this)),
                $currentSlide = _this.$element.find('.js-gallery-slide[data-index="'+ _this.gallery.getPos() +'"]');

            $currentSlide.trigger('slideHidden');

            // slide to the selected image
            _this.gallery.slide(index);

            // resize image on thumbnail click
            _this.calculateGalleryHeight();

            // ensure that thumbnails active class is switched
            var $currentThumb = $thumbs.eq(index);
            $thumbs.removeClass(activeClass);
            $currentThumb.addClass(activeClass);

            e.preventDefault();
        });

        // arrow event handler
        _this.$element.on('click', '.gallery-arrow', function(e) {
            var $thumbs = _this.$element.find('.thumbnails li'),
                index = _this.gallery.getPos(),
                $currentSlide = $(this).find('.js-gallery-slide[data-index="'+ _this.gallery.getPos() +'"]');

            $currentSlide.trigger('slideHidden');

            // if next arrow, check if on last slide
            // else if previous arrow, check if on first slide
            if ( $(this).hasClass('arrow-next') ) {
                if ( index === ($thumbs.length - 1) ) {
                    _this.gallery.slide(0);
                    $thumbs.eq(0).trigger('click');
                }
                else {
                    _this.gallery.slide(index + 1);
                    $thumbs.eq(index + 1).trigger('click');
                }
            }
            else {
                if ( index === 0 ) {
                    _this.gallery.slide($thumbs.length - 1);
                    $thumbs.eq($thumbs.length - 1).trigger('click');
                }
                else {
                    _this.gallery.slide(index - 1);
                    $thumbs.eq(index - 1).trigger('click');
                }
            }

            _this.calculateGalleryHeight();

            e.preventDefault();
        });

        // resize when window is resized
        UI.throttle(function(){
            _this.calculateGalleryHeight();
        });

        // resize when image is first loaded
        $($slideMedia).on('load', () => {
            _this.calculateGalleryHeight();
        });
    },

    destroySlideGallery : function(){
        this.gallery.kill();
    },

    destroyFadeGallery : function(){
        this.$element.replaceWith( _this.origElement );
    },

    calculateGalleryHeight : function(){
        var _this = this,
        $currentSlide = _this.$element.find('.js-gallery-slide:nth-child('+(_this.gallery.getPos() + 1)+')'),
        $slideMedia = $currentSlide.find('.js-gallery-slide-media'),
        newHeight = $slideMedia.height(),
        slideDescriptionHeight = $currentSlide.find('.slide-description').innerHeight();

        if( slideDescriptionHeight && slideDescriptionHeight > 0 ) {
            newHeight += slideDescriptionHeight;
        }

        // if images are already loaded we are safe to go ahead and updateHeights
        _this.updateHeights(newHeight);
    },

    updateHeights : function (newHeight) {
        var _this = this;

        _this.$element.find('.main-image').height(newHeight);
        _this.$element.find('.gallery-arrow').height(newHeight);
    },

    initFadeGallery : function(){
        var _this = this;

        _this.$element.addClass('image-slideshow ui-loading-background');

        var $slides = _this.$element.find('.js-gallery-slide');

        $slides.hide();

        _this.beginSlideshow();
    },

    beginSlideshow : function(){
        var _this = this,
            $slides = _this.$element.find('.js-gallery-slide'),
            instance = _this.$element.closest('.widget').attr('data-id');

        // remove the loading indicator
        _this.$element.removeClass('ui-loading-background');
        // Only show first if no slides are visible
        if ( ! $slides.find(':visible').length ){
            $slides.filter(':first').show();
        }

        // if more than one slide exists, start fading them in and out
        if ( $slides.length > 1 ){
            window.timers[instance] = setInterval(function(){
                _this.showNextSlide();
            }, _this.settings.delay);
        }
    },

    showNextSlide : function(){
        var _this = this,
            $currentSlide = _this.$element.find('.js-gallery-slide:visible'),
            hasNext = $currentSlide.next('.js-gallery-slide').index() != -1 ? true : false;

        var $nextSlide;
        var fadeInNextSlide = function () {
            // fade in next slide
            $nextSlide.fadeIn(
                parseInt( _this.settings.transition ),
                // after slide finishes fading in trigger custom event
                function () {
                    $nextSlide.trigger( 'slideShown' )
                }
            )
        };

        // handles looping back to the first slide
        if ( hasNext ) {
            $nextSlide = $currentSlide.next( '.js-gallery-slide' );
        } else {
            $nextSlide = $currentSlide.siblings( ':first' );
        }

        // fade out current slide
        $currentSlide
            .fadeOut(
                parseInt( _this.settings.transition ),
                // after slide finishes fading out trigger custom event and show next slide
                function () {
                    $currentSlide.trigger( 'slideHidden' );
                    fadeInNextSlide();
                }
            )
    },

    pauseSlideshow : function(){
        var _this = this,
            instance = _this.$element.closest('.widget').attr('data-id'),
            $slides = _this.$element.find('.js-gallery-slide');

        if ( $slides.length > 1 ){
            clearInterval(window.timers[instance]);

            _this.$element
                .find('.js-gallery-slide:visible .resume-slideshow-link').addClass('active')
                .off('click').on('click', function(e) {
                    e.preventDefault();
                    _this.showNextSlide();
                    $(this).removeClass('active');
                    _this.beginSlideshow();
                });
        }
    }
};

$.fn.gallery = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_gallery" ) ) {
            $.data( this, "qg_gallery", new Gallery( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};